import { render, staticRenderFns } from "./MeasuresPage.vue?vue&type=template&id=e20002a6&"
import script from "./MeasuresPage.vue?vue&type=script&lang=js&"
export * from "./MeasuresPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports